/** Strings of the creature feature (constructor «Облик», Animation Lab). Owner: Creature. */
export const creature = {
  'creature.screen.make': 'Облик',
  'creature.screen.animlab': 'Анимационная лаборатория',
} as const;
